import Auth from "~/services/Auth";

const Logout = () => {
  Auth.logout();

  return <></>;
};

export default Logout;
